import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";
import ActionButton from "./ActionButton";

interface AdvancedSearchButtonGroupProps {
  clearSearch: any;
  expandAdvanceSearch: any;
  isActive: boolean;
}
const AdvancedSearchButtonGroup = (props: AdvancedSearchButtonGroupProps) => {
  const { clearSearch, expandAdvanceSearch, isActive } = props;
  const { t } = useTranslation();
  return (
    <div className="flex justify-content-between padding-up-25">
      <div className="opensec-btn" onClick={() => expandAdvanceSearch()}>
        {isActive ? (
          <KeyboardDoubleArrowUpIcon />
        ) : (
          <KeyboardDoubleArrowDownIcon />
        )}
      </div>
      <div style={{ textAlign: "right" }}>
        <Button>
          <ActionButton
            type="submit"
            label={t("search")}
            action="search"
          ></ActionButton>
        </Button>
        <Button>
          <ActionButton
            label={t("clear")}
            type="button"
            onClick={() => clearSearch()}
            actionButtonStyle="outline"
          />
        </Button>
      </div>
    </div>
  );
};

export default AdvancedSearchButtonGroup;
